import { useRoutes } from "react-router-dom";
import "./App.css";
import { publicRoutes } from "./layout/routes/publicRoutes";
import { usePreventBackNavigation } from "./utils/helperdata";

function App() {
  const router = useRoutes(publicRoutes);
  // usePreventBackNavigation();
  return <div style={{ height: "100vh" }}>{router}</div>;
}

export default App;
